import { Component, inject } from '@angular/core';
import { ApiMembership, ApiMembershipProduct, ApiRetentionOfferSet, ApiUser } from '@tytapp/api';
import { DialogComponent, Redirection } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { environment } from 'environments/environment';
import { CancelMembershipComponent } from '../cancel-membership/cancel-membership.component';

@Component({
  selector: 'tyt-cancel-membership-retention',
  templateUrl: './cancel-membership-retention.component.html',
  styleUrls: ['./cancel-membership-retention.component.scss']
})
export class CancelMembershipRetentionComponent extends DialogComponent {
  private userService = inject(UserService);
  private redirection = inject(Redirection);

  offerSet: ApiRetentionOfferSet;
  callingComponent: CancelMembershipComponent;

  ready: boolean = false;

  membership: ApiMembership;
  selectedProduct: ApiMembershipProduct;
  periodChange: boolean = false;
  proratedCost: number;
  user: ApiUser;
  step: string = 'select-offer';
  newChargeDate: string;
  pwywPrice : number;
  pwywPeriod : string = 'monthly';

  init(offerSet: ApiRetentionOfferSet, callingComponent: CancelMembershipComponent) {
    this.offerSet = offerSet;
    this.ready = true;

    this.callingComponent = callingComponent;
    this.subscribe(this.userService.userChanged, async user => {
      this.user = user;
      if (!this.user) {
        this.userService.goToLogin();
        return;
      }

      if (this.user.rstatus) {
        this.redirection.go('/account/missing-payment');
        return;
      }

      this.membership = user.membership;
      this.pwywPeriod = {month: 'monthly', year: 'annually'}[this.membership.period];
    });
  }

  get membershipIsAnnual() {
    return (this.user && this.user.membership) ? this.user.membership.annual : false;
  }

  cancelMembershipClick() {
    this.close();
    this.callingComponent.allowCancellation();
  }

  get pwywMinimum() {
    if (this.pwywPeriod === 'monthly') {
      return this.offerSet.minimum_monthly_price;
    } else if (this.pwywPeriod === 'annually') {
      return this.offerSet.minimum_annual_price;
    }

    return Infinity;
  }

  get pwywPriceInRange() {
    if (!this.pwywPrice)
      return false;
    
    if (!this.offerSet)
      return false;
    
    return this.pwywMinimum <= this.pwywPrice*100;
  }

  get pwywValid() {
    return this.pwywPriceInRange;
  }
  
  frequencySuffixForPeriod(period : string) {
    if (period === 'monthly')
      return '/mo';
    else if (period === 'annually')
      return '/yr';
    return '';
  }

  submitPayWhatYouWant() {
    if (!this.pwywValid)
      return;
    
    this.redirection.go(`/membership/change/offers/${this.offerSet.uuid}/p:${Math.round(this.pwywPrice*100)}:${this.pwywPeriod}`);
    this.close();
  }

  get pixelEndpoint() {
    return `${this.offerSet.uuid}:x/pricing`;
  }

  get pixelUrl() {
    return `${environment.urls.api}/membership/offer_sets/${this.pixelEndpoint}/impression`;
  }

}
